module.exports = __webpack_public_path__ + "img/diy-question.f1619f50.svg";